import React from "react";
import { Button, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const DialogOKButton = styled(Button)({
    textTransform: "none", 
    color: "black", 
    backgroundColor: "#28b6c7", 
    "&.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.5)", 
      backgroundColor: "rgba(40, 182, 199, 0.5)", 
    },
})

export const DialogCancelButton = styled(Button)({
  textTransform: "none",
  color: "white",
})

export const DialogSubTitle = styled(Typography)({
  color: "white",
  textAlign: "center"
})